import payAdapter, { backAdapter } from '@/adapters/pay';
import accountAdapter from '@/adapters/account';

export default {
  namespaced: true,
  state: {
    account: null,
    charges: [],
    email: '',
  },
  getters: {
    sum({ charges }) {
      if (charges.length === 0) return 0;
      const sum = charges.reduce((acc, item) => acc + Number(item.value), 0);
      return Number(sum.toFixed(2));
    },
    diffSum({ charges }, getters) {
      const amount = charges.reduce((acc, item) => acc + Number(item.amount), 0);
      return getters.sum - Number(amount.toFixed(2));
    },
    balance({ account, charges }, getters) {
      if (!account || charges.length === 0) return 0;
      return account.debit + getters.sum;
    },
    hasNonpayment: (state, getters) => getters.balance < 0,
  },
  mutations: {
    setAccount(state, account) {
      state.account = account;
    },
    setCharges(state, charges) {
      state.charges = charges;
    },
    setEmail(state, email) {
      state.email = email;
    },
    clearAccount(state) {
      state.account = null;
    },
    clearCharges(state) {
      state.charges = [];
    },
    clearEmail(state) {
      state.email = '';
    },
  },
  actions: {
    getChargesByAccountId(ctx, accountId) {
      return this.$axios.post('/dvec/payment/init', {
        subscriber_id: accountId,
      })
        .then(({ data = {} }) => {
          const { pay = [], success, msg = '' } = data;
          if (!success) {
            throw new Error(msg);
          }
          return pay.map(payAdapter);
        });
    },
    getChargesByAccountCode(ctx, accountCode) {
      return this.$axios.post('/dvec/payment/anon/init', {
        subscriber_code: accountCode,
      })
        .then(({ data = {} }) => {
          const { pay = [], success, msg = '' } = data;
          if (!success) {
            throw new Error(msg);
          }
          const firstPay = pay.find((el) => el.SubscrID);
          const account = accountAdapter({
            SubscrId: firstPay?.SubscrID,
            SubscrCode: accountCode,
          });
          const charges = pay
            .filter((el) => el.SubscrID === firstPay?.SubscrID)
            .map(payAdapter);
          return { account, charges };
        });
    },
    createPayment({ state, getters }, isAuthenticated) {
      const host = isAuthenticated ? '/dvec/payment/create' : '/dvec/payment/anon/create';
      return this.$axios.post(host, {
        subscriber_id: state.account?.id,
        amount: String(getters.sum),
        payments: state.charges.map(backAdapter),
      })
        .then(({ data = {} }) => {
          const { paymentId, success, msg = '' } = data;
          if (!success || !paymentId) {
            throw new Error(msg);
          }
          return paymentId;
        });
    },
    fetchTransactionCode() {
      return this.$axios.get('/sbpilot/e/describe')
        .then(({ data = {} }) => {
          const { found, link } = data;
          if (found) {
            return link;
          }
          return null;
        });
    },
    confirmPayment(ctx, { paymentId, transactionCode }) {
      return this.$axios.post('/dvec/payment/confirm', {
        PaymentId: String(paymentId),
        TransactionCode: String(transactionCode),
      });
    },
    clearAll({ commit }) {
      commit('clearAccount');
      commit('clearCharges');
      commit('clearEmail');
    },
  },
};
